import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import type { AppStoreState } from '../types';

export const INIT_STATE: WrappedReducer<AppStoreState> = {
  loadingStatus: 0,
  loading: false,
  error: undefined,
  androidAppName: undefined,
  iosAppName: undefined,
  androidAppIdentifier: undefined,
  iosAppIdentifier: undefined,
  desktopAppUrl: undefined,
  qrCodeSettings: undefined,
  attributionLift: null,
  pamNotificationConfig: {
    loading: false,
  },
};
